import React, { createContext, useContext, useState, ReactNode } from "react";

interface MobileContextType {
  isLayerSelectionExpanded: boolean;
  setIsLayerSelectionExpanded: (expanded: boolean) => void;
  isStatsPanelExpanded: boolean;
  setIsStatsPanelExpanded: (expanded: boolean) => void;
  isTouch: boolean;
}

const MobileContext = createContext<MobileContextType | undefined>(undefined);

export const MobileProvider: React.FC<{
  children: ReactNode;
  isTouch: boolean;
}> = ({ children, isTouch }) => {
  const [isLayerSelectionExpanded, setIsLayerSelectionExpanded] =
    useState(false);
  const [isStatsPanelExpanded, setIsStatsPanelExpanded] = useState(false);

  return (
    <MobileContext.Provider
      value={{
        isLayerSelectionExpanded,
        setIsLayerSelectionExpanded,
        isStatsPanelExpanded,
        setIsStatsPanelExpanded,
        isTouch,
      }}
    >
      {children}
    </MobileContext.Provider>
  );
};

export const useMobileContext = () => {
  const context = useContext(MobileContext);
  if (context === undefined) {
    throw new Error("useMobileContext must be used within a MobileProvider");
  }
  return context;
};
